import React from "react";
import { useAuth } from "@byscott-io/corebyscott";
import { IssuePortal } from "@byscott-io/issuesbyscott_client";

// In-app support via the shared issuesbyscott portal (same pattern as the other
// apps). IssuePortal takes apiUrl/apiKey/user and wraps its own provider — the
// `user` (with external_id) is required, otherwise the portal never loads issues
// and sits on "loading issues". Config comes from window.ENV (set by the layout).
export default function SupportPage() {
  const { user, currentContainer } = useAuth();

  if (!user || !currentContainer) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Loading…</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Support</h1>
        <p className="text-gray-500">Get help and report issues</p>
      </div>
      <IssuePortal
        apiUrl={window.ENV?.ISSUESBYSCOTT_API_URL || "http://localhost:5003/api"}
        apiKey={window.ENV?.ISSUESBYSCOTT_API_KEY || ""}
        user={{
          email: user.email,
          external_id: currentContainer.id.toString(),
          name: currentContainer.name,
          external_user_id: user.id.toString(),
          external_user_name: user.full_name,
        }}
      />
    </div>
  );
}
